// Audience segment ("userType") — distinct from roles. Roles are capabilities
// (what you CAN do); userType is the experience segment (what you SEE: home
// surface, navigation, onboarding). Chosen at signup via the three-gate fork,
// pre-fork accounts are inferred from roles (see isStudioUser).
export const SEEKER_TYPE = "seeker";
export const EXPERT_TYPE = "expert";
export const ORGANIZATION_TYPE = "organization";

export type UserType =
  | typeof SEEKER_TYPE
  | typeof EXPERT_TYPE
  | typeof ORGANIZATION_TYPE;

export const USER_TYPES: UserType[] = [
  SEEKER_TYPE,
  EXPERT_TYPE,
  ORGANIZATION_TYPE,
];

export function getUserType(user: { userType?: string } | null | undefined): UserType | null {
  const value = user?.userType;
  return USER_TYPES.includes(value as UserType) ? (value as UserType) : null;
}

/**
 * Whether this user gets the coach/expert "Studio" shell (home + navigation).
 * Explicit userType wins; accounts that predate the signup fork are inferred
 * from the expert role instead of being interrupted with a chooser.
 */
export const isStudioUser = (
  user: { userType?: string; roles?: string[] } | null | undefined
) => {
  const type = getUserType(user);
  if (type) return type === EXPERT_TYPE;
  return (user?.roles ?? []).includes("expert");
};
